import { SchemaTypeDictionary } from '@/constants';
import type { SchemaType } from '@/store/forms/Asset-Editor/SchemaTypeOptions';

const getFileExtension = (filename: string) => {
  const dotIndex = filename.lastIndexOf('.');
  return dotIndex !== -1 ? filename.slice(dotIndex).toLowerCase() : '';
};

export const getCommonSchemaType = (files: File[]): SchemaType | null => {
  if (files.length === 0) return null;

  const extensionSet = new Set(files.map((file) => getFileExtension(file.name)));

  for (const [schemaType, extensions] of Object.entries(SchemaTypeDictionary)) {
    const allowedExtensions = new Set(extensions.map((ext) => ext.toLowerCase()));
    const isSameType = [...extensionSet].every((ext) => allowedExtensions.has(ext));
    if (isSameType) return schemaType as SchemaType;
  }

  return null;
};
